import AUStates from './id-ID/AU-states.json.js';
import CAStates from './id-ID/CA-states.json.js';
import CNStates from './id-ID/CN-states.json.js';
import CompanySize from './id-ID/company-size.json.js';
import CompanyType from './id-ID/company-type.json.js';
import countries from './id-ID/countries.json.js';
import DEStates from './id-ID/DE-states.json.js';
import HKStates from './id-ID/HK-states.json.js';
import INStates from './id-ID/IN-states.json.js';
import industry from './id-ID/industry.json.js';
import interests from './id-ID/interests.json.js';
import jobRole from './id-ID/job-role.json.js';
import levelOfAWSUsage from './id-ID/level-of-aws-usage.json.js';
import projectTimeline from './id-ID/project-timeline.json.js';
import PTStates from './id-ID/PT-states.json.js';
import USStates from './id-ID/US-states.json.js';
import useCase from './id-ID/use-case.json.js';
import languagePreference from './id-ID/language-preference.json.js';
import Navatar from '../id-ID/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
